module.exports = __webpack_public_path__ + "src/submodules/base/assets/img/gift-voicemod-icon.516369cc.svg";